<template>
  <div v-if="$route.query" class="align-items-center center">
    <img src='../assets/images/ford-logo.png' class="topbar-logo d-block" alt="Ford Logo"/>
    <h1 class="">Unauthorized</h1>
    <div v-if="$route.query.error_type === 'invalid_security_group'">
      <p>
        You do not have access to view this site. If you believe you should have access, please take the following actions:
      </p>
      <ul>
        <li>Navigate to <a href="https://iam.ford.com/IdentityManagement/default.aspx" target="_blank" class="fds-decoration--underline">https://iam.ford.com/IdentityManagement/default.aspx</a></li>
        <li>Click "Join a SG"</li>
        <li>Search for "TechDrive-Field-Ops"</li>
        <li>Select the check box next to the security group, then click "Join" in the header bar</li>
        <li>Enter a justification for requesting  access in the popup (failure to include justification will result in access denial)</li>
        <li>Click Submit</li>
      </ul>
    </div>
    <button class="btn btn-primary float-right" @click="logout">Logout</button>
  </div>
</template>

<script>
export default {
  name: "Authorized",
  created() {
    if (this.$route.query.token) {
      localStorage.setItem('id_token', this.$route.query.token);
      this.$router.push({ path: '/' });
    }
  },
  methods: {
    logout() {
      localStorage.removeItem('id_token');
      this.$router.push({ name: 'Home'});
    },
  },
}
</script>

<style lang="scss" scoped>
.topbar-logo {
  max-width: 282px;
  max-height: 99px;
}

.center {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%); /* for IE 9 */
  -webkit-transform: translate(-50%, -50%); /* for Safari */
}
</style>
